import React from 'react';
import { Link } from 'react-router-dom';
import { TwitterIcon, LinkedinIcon, FacebookIcon, YoutubeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-au-green-dark text-white" data-id="element-172">
      <div className="h-1 bg-au-gold" data-id="element-173"></div>
      <div className="max-w-7xl mx-auto px-4 py-12" data-id="element-174">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8" data-id="element-175">
          <div data-id="element-176">
            <h3 className="font-bold text-lg mb-4" data-id="element-177">About</h3>
            <ul className="space-y-2" data-id="element-178">
              <li data-id="element-179">
                <Link to="/about" className="hover:text-au-gold transition-colors" data-id="element-180">
                  About Us
                </Link>
              </li>
              <li data-id="element-181">
                <Link to="/about" className="hover:text-au-gold transition-colors" data-id="element-182">
                  Leadership
                </Link>
              </li>
              <li data-id="element-183">
                <Link to="/about" className="hover:text-au-gold transition-colors" data-id="element-184">
                  Mandate
                </Link>
              </li>
              <li data-id="element-185">
                <a href="#" className="hover:text-au-gold transition-colors" data-id="element-186">
                  Careers
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-187">
            <h3 className="font-bold text-lg mb-4" data-id="element-188">Procurement</h3>
            <ul className="space-y-2" data-id="element-189">
              <li data-id="element-190">
                <Link to="/bids" className="hover:text-au-gold transition-colors" data-id="element-191">
                  Bids & Tenders
                </Link>
              </li>
              <li data-id="element-192">
                <Link to="/procurement/annual-plan" className="hover:text-au-gold transition-colors" data-id="element-193">
                  Annual Plan
                </Link>
              </li>
              <li data-id="element-194">
                <Link to="/procurement/contract-awards" className="hover:text-au-gold transition-colors" data-id="element-195">
                  Contract Awards
                </Link>
              </li>
              <li data-id="element-196">
                <Link to="/procurement/supplier-registration" className="hover:text-au-gold transition-colors" data-id="element-197">
                  Supplier Registration
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-198">
            <h3 className="font-bold text-lg mb-4" data-id="element-199">Resources</h3>
            <ul className="space-y-2" data-id="element-200">
              <li data-id="element-201">
                <Link to="/projects" className="hover:text-au-gold transition-colors" data-id="element-202">
                  Projects
                </Link>
              </li>
              <li data-id="element-203">
                <Link to="/procurement/manual" className="hover:text-au-gold transition-colors" data-id="element-204">
                  Procurement Manual
                </Link>
              </li>
              <li data-id="element-205">
                <a href="#" className="hover:text-au-gold transition-colors" data-id="element-206">
                  Publications
                </a>
              </li>
              <li data-id="element-207">
                <a href="#" className="hover:text-au-gold transition-colors" data-id="element-208">
                  Media Centre
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-209">
            <h3 className="font-bold text-lg mb-4" data-id="element-210">Contact</h3>
            <p className="mb-2" data-id="element-211">African Union Commission</p>
            <p className="mb-2" data-id="element-212">London Office, United Kingdom</p>
            <p className="mb-2" data-id="element-213">info@aucommission.org</p>
            <p data-id="element-214">+44 (0) 20 4571 0123 (Procurement)</p>
            <p data-id="element-215">+44 (0) 20 4571 1964</p>
          </div>
        </div>

        <div className="border-t border-au-green pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-216">
          <div className="flex items-center gap-4" data-id="element-217">
            <a href="#" className="hover:text-au-gold transition-colors" data-id="element-218">
              <TwitterIcon size={20} data-id="element-219" />
            </a>
            <a href="#" className="hover:text-au-gold transition-colors" data-id="element-220">
              <LinkedinIcon size={20} data-id="element-221" />
            </a>
            <a href="#" className="hover:text-au-gold transition-colors" data-id="element-222">
              <FacebookIcon size={20} data-id="element-223" />
            </a>
            <a href="#" className="hover:text-au-gold transition-colors" data-id="element-224">
              <YoutubeIcon size={20} data-id="element-225" />
            </a>
          </div>
          <p className="text-sm text-gray-300" data-id="element-226">
            © 2026 African Union. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}